export default {
  getCurrentSchool(state) {
    return state.currentSchool;
  },
  getSuggestions(state) {
    return state.suggestions;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/adminPortal/getters.js